import { GET_PUSH_NOTIFICATION } from '../actions/types'

interface PushNotificationState {
  show: boolean
  data: {
    title: string
    body: string
    openURL: string
    icon?: string
  }
}

export const initialPushNotification: PushNotificationState = {
  show: false,
  data: {
    title: '',
    body: '',
    openURL: '',
  },
}

export interface PushNotificationProps extends PushNotificationState {
  type: string
}

export const pushNotification = (
  state: PushNotificationState = initialPushNotification,
  action: PushNotificationProps,
) => {
  switch (action.type) {
    case GET_PUSH_NOTIFICATION:
      return { data: action.data, show: action.show }

    default:
      return state
  }
}
